module.exports = __webpack_public_path__ + "img/light.e94cf6b9.webp";